import type { CanMatchFn } from '@angular/router';

/** Submódulos de Tesorería con pantalla real (o su redirect). El resto, y el hub, son del prototipo. */
export const SUBMODULOS_REALES_TESORERIA: readonly string[] = ['cartera', 'cobros-pagos'];

/**
 * `canMatch` del montaje `tesoreria` de `app.routes.ts`: solo casa con `/tesoreria/cartera…` y
 * `/tesoreria/cobros-pagos`.
 *
 * Por qué hace falta: sin él, `path: 'tesoreria'` se quedaba con `/tesoreria` entera. Sus hijas no
 * tienen ruta `''`, el router no vuelve atrás a probar el prototipo y el hub no se pintaba (ninguna
 * tarjeta). Con `canMatch` en `false` el router SÍ pasa a la siguiente ruta, así que el hub y las
 * demás tarjetas siguen viniendo del prototipo, y la cartera conserva su nivel «Tesorería» en las migas
 * (Tesorería › Cartera › código), con «Tesorería» enlazando al hub.
 */
export const esSubmoduloRealDeTesoreria: CanMatchFn = (_route, segments) =>
  SUBMODULOS_REALES_TESORERIA.includes(segments[1]?.path ?? '');
